"use client";

import { LanguageSelector } from "@/components/booking/LanguageSelector";
import { useTranslation } from "react-i18next";
import { useRouter, useSearchParams } from "next/navigation";
import CustomerProfileDropdown from "./customer-profile-dropdown";

interface CustomerPortalHeaderProps {
  userEmail: string;
  availableLanguages?: string[];
}

export function CustomerPortalHeader({
  userEmail,
  availableLanguages,
}: CustomerPortalHeaderProps) {
  const { t } = useTranslation();
  const router = useRouter();
  const searchParams = useSearchParams();

  return (
    <div className="border-b">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Left side - On Air logo */}
          <img
            src="https://onair-prod-assets.s3.eu-west-1.amazonaws.com/app-assets/on-air-logo.png"
            alt="On Air Game Shows"
            className="h-8 sm:h-9 md:h-10 w-auto p-2 rounded-lg shadow-md"
            style={{
              backgroundImage:
                "url(https://onair-prod-assets.s3.eu-west-1.amazonaws.com/app-assets/footer-background-sm.jpg)",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />

          {/* Right side - My Bookings, language selector, and userrrrrr menu */}
          <div className="flex items-center gap-2 sm:gap-4">
            {/* Desktop: show title and language inline */}
            <div className="hidden sm:flex sm:items-center sm:gap-4">
              <button
                onClick={() => {
                  const lang = searchParams.get("lang");
                  const url = lang
                    ? `/customerportal/bookings?lang=${lang}`
                    : "/customerportal/bookings";
                  router.push(url);
                }}
                className="text-lg font-medium hover:underline focus:outline-none focus:underline"
              >
                {t("customerPortal.myBookings")}
              </button>
            </div>

            {/* Mobile: show title only */}
            <div className="sm:hidden">
              <button
                onClick={() => {
                  const lang = searchParams.get("lang");
                  const url = lang
                    ? `/customerportal/bookings?lang=${lang}`
                    : "/customerportal/bookings";
                  router.push(url);
                }}
                className="text-sm font-medium hover:underline focus:outline-none focus:underline"
              >
                {t("customerPortal.myBookings")}
              </button>
            </div>

            <LanguageSelector
              variant="compact"
              availableLanguages={availableLanguages}
            />
            <CustomerProfileDropdown userEmail={userEmail} />
          </div>
        </div>
      </div>
    </div>
  );
}
